import { objectSchema } from "vue-utils"
import type { IncidentEntity } from "./IncidentEntity"
import { UserTimeStamp } from "./UserTimeStamp"

export interface NoteEntry extends IncidentEntity {
	text: string
	creationMetadata: UserTimeStamp
}

export const NoteEntry = objectSchema<NoteEntry>({
	id: Number,
	text: String,
	creationMetadata: UserTimeStamp,
})
